import {
    ApiService,
    ApiServiceUnitConversion,
    EnumServiceType,
    EnumUnit,
    getEnumServiceTypeLabel,
    serviceTypeOptions,
    getEnumUnitLabel,
    unitOptions,
} from '@Model';

import { Column } from '@synqo/frontend-component-library';

export const serviceColumns: Column<ApiService>[] = [
    { name: 'number', label: 'Nummer' },
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Bezeichnung' },
    {
        name: 'unit',
        label: 'Einheit',
        filterVariant: 'select',
        filterOptions: unitOptions,
        renderCell: ({ cellData }) => getEnumUnitLabel(cellData as EnumUnit),
    },
    {
        name: 'type',
        label: 'Art',
        filterVariant: 'select',
        filterOptions: serviceTypeOptions,
        renderCell: ({ cellData }) => getEnumServiceTypeLabel(cellData as EnumServiceType),
    },
];

export const conversionColumns: Column<ApiServiceUnitConversion>[] = [
    {
        name: 'source_unit',
        label: 'Quell-Einheit',
        renderCell: ({ rowData }) => `1 ${getEnumUnitLabel(rowData.source_unit)} entspricht`,
    },
    {
        name: 'factor',
        label: 'Faktor',
    },
    {
        name: 'target_unit',
        label: 'Ziel-Einheit',
        renderCell: ({ rowData }) => getEnumUnitLabel(rowData.target_unit),
    },
];
